export default __webpack_public_path__ + "static/media/smartly-patern.9c00f783.svg";